enum MemberAge {
  ThirteenToSeventeen = 'THIRTEEN_TO_SEVENTEEN',
  EighteenToThirtyFour = 'EIGHTEEN_TO_THIRTY_FOUR',
  ThirtyFiveToFortyFour = 'THIRTY_FIVE_TO_FORTY_FOUR',
  OverFortyFive = 'FORTY_FIVE_PLUS',
}

export default MemberAge;
